import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AuthService } from "@services";
import { Subscription } from "rxjs";

@Component({
  selector: 'app-advance-line',
  templateUrl: './advance-line.component.html',
  styleUrls: [ './advance-line.component.scss' ]
})
export class AdvanceLineComponent implements OnInit, OnDestroy {

  @Input() step: number = 2;
  @Input() currentStep: number = 50;
  @Output() choiceRespSection = new EventEmitter<boolean>();
  @Output() choiceRegisSection = new EventEmitter<boolean>();
  subscriptionLogged: Subscription;

  logged: boolean = false;

  constructor(private authService: AuthService) {
  }

  ngOnInit(): void {
    this.subscriptionLogged = this.authService.currentUser$
      .subscribe(resp => this.logged = !!resp);
  }

  ngOnDestroy() {
    if (this.subscriptionLogged) {
      this.subscriptionLogged.unsubscribe();
    }
  }

  showResponseSection() {
    if (!this.logged) return;

    this.step = 4;
    this.currentStep = 100;
    this.choiceRespSection.emit(true);
  }

  showRegisterRequestSection() {
    if (!this.logged) return;

    this.step = 2;
    this.currentStep = 50;
    this.choiceRegisSection.emit(true);
  }

}
